/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 *総合契約
 */
export interface Sgkb575aResCombinedcontract {
    /** 
     * 開通受付番号：半角数字
     */
    provAceptNo?: string;
    /** 
     * 開通受付履歴番号：半角数字
     */
    provAceptRrkno?: string;
    /** 
     * 開通受付履歴番号通番：半角数字
     */
    provisionacceptanceRrknoSerialnumber?: string;
    /** 
     * 更新通番号：半角数字
     */
    updateSrno?: string;
    /** 
     * ガス供給地点特定番号：半角数字
     */
    gasSuppntSpno?: string;
    /** 
     * 使用需要者区分：半角英数混在
     */
    usingJuyoshaDiv?: string;
    /** 
     * 使用需要者区分名称：全角半角混在
     */
    usingjyuyoshaDivaname?: string;
    /** 
     * 使用お客さまカナ氏名：半角英数混在
     */
    usingVisitKananame?: string;
    /** 
     * 使用お客さま漢字氏名：半角英数混在
     */
    usingVisitKnjnm?: string;
    /** 
     * 使用お客さま電話番号コード１：半角英数混在
     */
    usingVisitTeldivision1?: string;
    /** 
     * 使用お客さま電話番号コード１名称：全角半角混在
     */
    usevisitteldiv1Aname?: string;
    /** 
     * 使用お客さま電話番号１：電話番号(ハイフンと数値含む)
     */
    usingVisitTel1?: string;
    /** 
     * 使用お客さま電話番号コード２：半角英数混在
     */
    usingVisitTeldivision2?: string;
    /** 
     * 使用お客さま電話番号コード２名称：全角半角混在
     */
    usevisitteldiv2Aname?: string;
    /** 
     * 使用お客さま電話番号２：電話番号(ハイフンと数値含む)
     */
    usingVisitTel2?: string;
    /** 
     * 使用お客さま電話番号コード３：半角英数混在
     */
    usingVisitTeldivision3?: string;
    /** 
     * 使用お客さま電話番号コード３名称：全角半角混在
     */
    usevisitteldiv3Aname?: string;
    /** 
     * 使用お客さま電話番号３：電話番号(ハイフンと数値含む)
     */
    usingVisitTel3?: string;
    /** 
     * メーター指針値：半角数値(小数点なし)
     */
    meterShshnch?: number;
}